import React, { StrictMode } from "react";
import { ApolloProvider } from "@apollo/client";
import { client } from "./apollo/client";
import { BrowserRouter } from "react-router-dom";
import { RvPriceTotalTableInfo } from "./components/RvPriceTotalTableInfo";

export const RvPriceTotalTableInfoApp = () => (
  <StrictMode>
    <ApolloProvider client={client}>
      <BrowserRouter>
        <RvPriceTotalTableInfo />
      </BrowserRouter>
    </ApolloProvider>
  </StrictMode>
);
